import $ from 'jquery';
import 'jquery-ui';

window.ManualSolicitationFormObject = {
  last: null,
  maybeHideChannelLabels: function () {
    if ($('#channel-icons label:visible').length == 1) {
      $('#channel-icons label').hide();
      $('#channel-icons').hide();
    } else {
      $('#channel-icons').show();
    }
  },
  updateChannels: function (channelsString) {
    var channels = $.parseJSON(channelsString);
    $('#channel-icons label').hide();
    channels.forEach(function (channel) {
      var selector = '#channel-icons label.' + channel;
      $(selector).show();
      $('.js-multiple-channel[value="' + channel + '"]').prop('checked', true);
    });
    this.maybeHideChannelLabels();
  },
  setupManualSolicitationForm: function () {
    if ($('#solicitation_employee_id').length) {
      $('#solicitation_employee_id').combobox();
      this.last = $('#solicitation_employee_id option:selected')[0];
      if (!this.last || typeof this.last.dataset.channels === 'undefined') {
        return;
      }
      this.updateChannels(this.last.dataset.channels);
    } else {
      this.maybeHideChannelLabels();
    }
  },
};

$(function () {
  window.ManualSolicitationFormObject.setupManualSolicitationForm();
});

// edited from https://jqueryui.com/autocomplete/#combobox
(function ($) {
  $.widget('custom.combobox', {
    _create: function () {
      this.wrapper = $('<span>')
        .addClass('custom-combobox')
        .insertAfter(this.element);

      this.element.hide();
      this._createAutocomplete();
    },

    _createAutocomplete: function () {
      var selected = this.element.children(':selected'),
        value = selected.val() ? selected.text() : '';

      this.input = $('<input>')
        .appendTo(this.wrapper)
        .val(value)
        .attr('title', '')
        .addClass('js-employee-input form-control')
        .attr('placeholder', 'Enter team member name')
        .attr('required', true)
        .autocomplete({
          delay: 0,
          minLength: 0,
          source: $.proxy(this, '_source'),
        })
        .tooltip({
          tooltipClass: 'ui-state-highlight',
        })
        .bind('focus', function () {
          $(this).autocomplete('search', '');
        });

      this._on(this.input, {
        autocompleteselect: function (event, ui) {
          ui.item.option.selected = true;
          last = ui.item.option;
          this._trigger('select', event, {
            item: ui.item.option,
          });
          window.ManualSolicitationFormObject.updateChannels(
            ui.item.option.dataset.channels,
          );
        },

        autocompletechange: '_removeIfInvalid',
      });
    },

    _source: function (request, response) {
      var matcher = new RegExp(
        $.ui.autocomplete.escapeRegex(request.term),
        'i',
      );
      response(
        this.element.children('option').map(function () {
          var text = $(this).text();
          if (this.value && (!request.term || matcher.test(text))) {
            return {
              label: text,
              value: text,
              option: this,
            };
          }
        }),
      );
    },

    _removeIfInvalid: function (event, ui) {
      // Selected an item, nothing to do
      if (ui.item) {
        return;
      }

      // Search for a match (case-insensitive)
      var value = this.input.val(),
        valueLowerCase = value.toLowerCase(),
        valid = false;
      this.element.children('option').each(function () {
        if ($(this).text().toLowerCase() === valueLowerCase) {
          this.selected = valid = true;
          return false;
        }
      });

      // Found a match, nothing to do
      if (valid) {
        return;
      }

      last.selected = true;
      this.input.val(last.innerHTML);
    },

    _destroy: function () {
      this.wrapper.remove();
      this.element.show();
    },
  });
})($);
